import React from 'react';
import classnames from 'classnames';
import { isColorDark, fixColor } from '@/utils';

export interface IModuleBaseProps extends React.HTMLAttributes<HTMLElement> {
  data: any;
  moduleName: string;
  className?: string;
  tag?: string;
}

const ModuleBase = ({ data, className, tag, moduleName, ...props }: IModuleBaseProps) => {
  const classes = ['module', className];

  const backgroundColor = fixColor(data?.backgroundColour);

  if (data?.paddingTop) {
    if (data.paddingTop.toLowerCase() === 'medium') {
      classes.push('pt-10 lg:pt-16');
    } else if (data.paddingTop.toLowerCase() === 'large') {
      classes.push('pt-16 lg:pt-26');
    } else if (data.paddingTop.toLowerCase() !== 'none') {
      classes.push('pt-6 lg:pt-10');
    }
  }

  if (data?.paddingBottom) {
    if (data.paddingBottom.toLowerCase() === 'medium') {
      classes.push('pb-10 lg:pb-16');
    } else if (data.paddingBottom.toLowerCase() === 'large') {
      classes.push('pb-16 lg:pb-26');
    } else if (data.paddingBottom.toLowerCase() !== 'none') {
      classes.push('pb-6 lg:pb-10');
    }
  }

  if (isColorDark(backgroundColor)) {
    classes.push('[&_.color-from-bg]:text-white');
  } else {
    classes.push('[&_.color-from-bg]:text-black');
  }

  classes.push(moduleName || undefined);

  return React.createElement(tag?.toLowerCase() || 'section', {
    id: data?.anchor || null,
    style: {
      backgroundColor,
    },
    className: classnames(classes),
    ...props,
  });
};

export default ModuleBase;
